document.addEventListener('DOMContentLoaded', () => {
  function calcularPorciones(container) {
    const itemPorciones = document.querySelector('.item-porciones');
    const spanResultado = document.querySelector('.item-porciones > p > span');
    if (!itemPorciones || !spanResultado) return;

    const inputCantidad = container.querySelector('input[name="custom-quantity"]');
    if (!inputCantidad) return;

    const valorInput = Number(inputCantidad.value);
    const valorPorciones = Number(itemPorciones.getAttribute('value'));
    const resultado = valorInput * valorPorciones;
    spanResultado.textContent = resultado;
  }

  setTimeout(function() {
    document.body.addEventListener('click', (event) => {
      const quantityBreak = event.target.closest('.quantity-break');
      if (quantityBreak) {
        calcularPorciones(quantityBreak);
      }
    });
  }, 1000);
});